import api from '@/helpers/api';

import type {
	CreateInterviewPayload,
	InterviewAiSuggestionsPayload,
	InterviewAiSuggestionsResponse,
	InterviewAiSummaryPayload,
	InterviewAiSummaryResponse,
	InterviewReport,
	UpdateInterviewPayload,
} from '@/modules/worker/services/types';

const interviewService = {
	async getInterviews(workerId: string): Promise<InterviewReport[]> {
		const response = await api.request<InterviewReport[]>({
			url: `/workers/${workerId}/interviews`,
			method: 'GET',
		});
		return response.data;
	},

	async createInterview(
		workerId: string,
		data: CreateInterviewPayload
	): Promise<InterviewReport> {
		const response = await api.request<InterviewReport>({
			url: `/workers/${workerId}/interviews`,
			method: 'POST',
			data,
		});
		return response.data;
	},

	async updateInterview(
		workerId: string,
		interviewId: string,
		data: UpdateInterviewPayload
	): Promise<void> {
		await api.request<void>({
			url: `/workers/${workerId}/interviews/${interviewId}`,
			method: 'PATCH',
			data,
		});
	},

	async postInterviewAiSuggestions(
		workerId: string,
		payload: InterviewAiSuggestionsPayload
	): Promise<InterviewAiSuggestionsResponse> {
		const response = await api.request<InterviewAiSuggestionsResponse>({
			url: `/workers/${workerId}/interviews/ai/suggestions`,
			method: 'POST',
			data: payload,
		});
		return response.data;
	},

	async generateAiSummary(
		workerId: string,
		data: InterviewAiSummaryPayload
	): Promise<InterviewAiSummaryResponse> {
		const response = await api.request<InterviewAiSummaryResponse>({
			url: `/workers/${workerId}/interviews/ai/summary`,
			method: 'POST',
			data,
		});
		return response.data;
	},
};

export default interviewService;
